import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'timeAgo',
  pure: true
})
export class TimeAgoPipe implements PipeTransform {

  private _now: Date;
  private get now() {
    if (!this._now) {
      this._now = new Date();
    }
    return this._now;
  }

  transform(value: Date, ...args: any[]): any {
    if (!value || new Date(value) >= this.now) {
      return null;
    }
    if (this.isMoreThan1YearDifference(value, this.now)) {
      return this.timeAgoMoreThan1Year(value);
    } else {
      return this.timeAgoUpTo1Year(value);
    }
  }

  isMoreThan1YearDifference(date1: Date, date2: Date): boolean {
    const monthsDiff = moment(date2).diff(moment(date1), 'months');
    return Math.abs(monthsDiff) > 12;
  }

  timeAgoUpTo1Year(date: Date) {
    return moment(date).fromNow();
  }

  timeAgoMoreThan1Year(date: Date) {
    const diffInMonths = Math.round(moment(this.now).diff(moment(date), 'months', true));
    const fullYears = Math.floor(diffInMonths / 12);
    const remaindMonths = diffInMonths % 12;
    let result = fullYears === 1 ? 'a year' : `${fullYears} years`;
    if (remaindMonths > 0) {
      result = `${result} and ${remaindMonths} ${remaindMonths === 1 ? ' month' : 'months'}`;
    }
    result += ' ago';
    return result;
  }
}
